
import { useNavigate } from 'react-router-dom';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './landingpage.module.scss';
import Footer from '../footer/Footer';

export default function LandingPage() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    //const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();

    return (
        <>
            <div style={{ minHeight: "100vh", margin: "0", display: "flex", flexDirection: "column" }}>
                <div className={styles.bwrapper}>
                    <div className="container">

                        {/*auth.isAuthCheckFinished === false &&
                        <><div>Lädt...</div></>
                    */}

                        <LandingpageHeader />

                        <div>

                            <div style={{ marginTop: "5em" }}>
                                <h3 style={{ textAlign: "center" }}>Beratung und Umsetzung von IT Projekten</h3>
                            </div>

                            <div style={{ marginTop: "3em" }}>
                                Ihr Vorteil bei uns:
                            </div>

                            <div className={styles.fpVorteil}>
                                <div className={styles.card_lp_1} style={{ textAlign: "center" }}>Einfach</div>
                                <div className={styles.card_lp_1} style={{ textAlign: "center" }}>Schnell</div>
                                <div className={styles.card_lp_1} style={{ textAlign: "center" }}>Direkt</div>
                            </div>

                            <div style={{ marginTop: "3em" }}>
                                Sie suchen eine digitale Lösung in Ihrem Unternehmen? Lassen Sie sich von uns beraten oder finden bereits jetzt das richtige <button className="btn btn-light" onClick={ () => navigate("/produkte")}>Produkt</button> für Ihr Unternehmen.
                            </div>

                        </div >

                    </div >
                </div>
                <Footer />
            </div >
        </>
    );
}
